module.exports = __webpack_public_path__ + "img/Balance-3-mobile.1e3618e2.jpg";